<template>
  <div ref="boxofficefnb_SalesReceipt" class="d-none">
    <div v-html="EjsData"></div>
    <!-- <div>
      <table style="width:320px;font-size: 12px;border:none;">
        <thead>
          <tr>
            <th>
              <p style="margin:0;">{{bookingDetails.cine_name}}</p>
              <p style="margin:3px;">{{bookingDetails.cine_phone}}</p>
            </th>
          </tr>

          <tr>
            <th colspan="2">
              <p style="font-size: 10px;margin:0">Sales Receipt</p>
              <span>{{ currentDate }}</span>
            </th>
            <th style="text-align:right;">
              <p style="font-size: 10px;margin:0;">Transaction No:</p>
              <span>{{ bookingDetails.sb_booking_code }}</span>
            </th>
          </tr>

          <tr>
            <td colspan="3" style="border-top:1px dashed #404040;"></td>
          </tr>

          <tr>
            <th style="width: 60%;text-align:left;">
              <p style="color: #404040;margin:3px;">DESCRIPTION</p>
            </th>
            <th style="width:15%;text-align:center;">
              <p style="color: #404040;margin:3px;">QTY</p>
            </th>
            <th style="width:25%;text-align:right;">
              <p style="color: #404040;margin:3px;">PRICE</p>
            </th>
          </tr>

          <tr>
            <td colspan="3" style="border-top:1px dashed #404040;"></td>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td colspan="3">
              <p style="margin:15px 0 5px 0;font-size:10px;color:#484848;">BOOKING SUMMARY:</p>
            </td>
          </tr>

          <tr>
            <td style="text-align:left;">
              <p
                style="margin: 1px 0;"
              >{{ bookingDetails.movie_title }}-{{bookingDetails.mf_name}}-{{bookingDetails.lang_name}}</p>
              <p
                style="margin:1px 0;"
              >{{ bookingDetails.og_show_date | dateparse }} {{ bookingDetails.og_show_time | timeparseAmPm }}</p>
              <p
                :key="seatType+seatTypeIndex"
                style="margin:2px 0;"
                v-for="(seatType, seatTypeIndex) in bookingDetails.uniqueSeatTypes"
              >
                ({{bookingDetails.screen_name}}:
                <span>{{seatType}} - {{bookingDetails.seats}}</span>
                <span v-if="seatTypeIndex + 1 < bookingDetails.uniqueSeatTypes.length">,</span>)
              </p>
            </td>

            <td style="text-align:center;vertical-align:top;">
              <p
                style="margin:1px 0;"
              >{{ bookingDetails["seats_types"] ? bookingDetails["seats_types"].length : '' }}</p>
            </td>

            <td style="text-align:right;vertical-align:top;">
              <p style="margin:0;padding: 1px 0;">{{ netAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr
            :key="Charges.ct_name+ChargesIndex"
            v-for="(Charges, ChargesIndex) in AdditionalCharges"
          >
            <td colspan="2">
              <p style="margin:1px 0;">{{Charges.ct_name}}</p>
            </td>

            <td style="text-align: right;">
              <p style="margin:1px 0;">{{ Charges.sp_value.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="3" style="padding-top: 3px;border-top:1px dashed #404040;"></td>
          </tr>

          <tr>
            <td colspan="2">
              <p style="margin:0 0 15px 0;font-weight:bold;">Booking Total:</p>
            </td>
            <td style="text-align:right;">
              <p
                style="margin:0 0 15px 0;font-weight:bold;"
              >{{ getcurrency }} {{ totalAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="3">
              <p style="margin:0 0 5px 0;font-size:10px;color:#484848;">CONCESSION SUMMARY</p>
            </td>
          </tr>

          <tr v-for="(item, itemIndex) in Items" :key="item.item_name+itemIndex">
            <td style="text-align:left;">{{ item.item_name || item.recipe_name }}</td>
            <td style="text-align:center;">{{ item.quantity }}</td>
            <td style="text-align:right;">{{ item.fp_amount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
          </tr>

          <tr
            v-if="Items && Items.length > 0"
            v-for="(Tax,TaxIndex) in Taxes"
            :key="TaxIndex + Tax.ct_name"
          >
            <td colspan="2">
              <p style="margin:1px 0;">{{Tax.ct_name}}</p>
            </td>
            <td style="text-align:right;">
              <p style="margin:1px 0;">{{ Tax.totalTax.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="3" style="border-top:1px dashed #404040;"></td>
          </tr>

          <tr v-if="Items && Items.length > 0">
            <td colspan="2" style="text-align: left; font-weight: bold;">
              <p style="margin:0 0 15px 0;font-weight:bold;">Concession Total:</p>
            </td>
            <td style="text-align:right;">
              <p
                style="margin:0 0 15px 0;font-weight:bold;"
              >{{ getcurrency }} {{ FnBItemsTotalPrice.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr
            v-if="getSelectedOffer && getSelectedOffer.offer_print_on_ticket == 'Y' || offerFor == 'vouchers'"
            style="border-bottom: 1px dashed #000000"
          >
            <td colspan="2" style="text-align: left;">
              <div style="font-weight: bold;">Discount</div>
              {{ getSelectedOffer.offer_title || getSelectedOffer.voucher_title }}
            </td>
            <td
              colspan="3"
              style="text-align: right; vertical-align: bottom"
            >{{ getcurrency }} {{ offerPrice }}</td>
          </tr>
          <tr>
            <td>
              <p style="margin: 3px;font-size: 14px;font-weight:bold;">GRAND TOTAL</p>
            </td>
            <td colspan="2" style="text-align: right;">
              <p
                style="margin: 3px;font-size: 14px;font-weight:bold;"
              >{{ getcurrency }} {{ (totalAmount + FnBItemsTotalPrice).toFixed(this.MIN_FRACTION_DIGITS) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="3" style="border-top:1px solid #404040;"></td>
          </tr>

          <tr>
            <td colspan="3">
              <div>Sold By: {{ name }}</div>
              <div>Sold on: {{ hardwarename && hardwarename.length > 0 ? hardwarename : '-' }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>-->
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosService from "@/services/PosService";
import moment from "moment";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      currentDate: "",
      name: "",
      EjsData: null
    };
  },
  props: {
    printText: {
      type: String,
      default: "Print"
    },
    onClickHandler: {
      type: Function
    },
    itemsList: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      default: ""
    },
    subTotal: {
      type: Number,
      default: null
    },
    total: {
      type: Number,
      default: null
    },
    taxes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taxesTotal: {
      type: Number,
      default: null
    },
    onNumberSubmit: {
      type: Function
    },
    onPrintCall: {
      type: Function
    }
  },
  computed: {
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
    hardwarename() {
      return this.$store.getters.gethardwarename;
    },
    paymentDetails() {
      return this.$store.getters.selectedPaymentMode;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    getTaxAmount() {
      let TaxValue = null;
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          TaxValue += e.sp_value;
        });
        return TaxValue;
      } else {
        return (TaxValue = 0.0);
      }
    },
    getTotal() {
      let Total = null;

      Total = this.netAmount + this.getTaxAmount;
      return Total;
    },
    offerFor() {
      return this.$store.getters.getOfferFor;
    },
    getSelectedOffer() {
      return this.$store.getters.getSelectedOffer;
    },
    offerPrice() {
      return this.$store.getters.getOfferPrice
        ? parseFloat(this.$store.getters.getOfferPrice).toFixed(this.MIN_FRACTION_DIGITS)
        : 0;
    },
    fnbtotalvalue() {
      return this.$store.getters.FnBTotalValue;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    Items() {
      return this.itemsList;
    },
    Currency() {
      return this.currency;
    },
    SubTotal() {
      return this.subTotal ? this.subTotal : null;
    },
    Total() {
      return this.subTotal !== null && this.taxesTotal !== null
        ? this.subTotal + this.taxesTotal
        : null;
    },
    Taxes() {
      return this.taxes;
    },
    getTotalFnBTax() {
      let taxes = null;

      if (this.Taxess && this.Taxes.length > 0) {
        this.Taxes.forEach(e => {
          taxes += e.totalTax;
        });
        return taxes;
      } else {
        return (taxes = 0.0);
      }
    },
    FnbNetAmount() {
      let fnbamount = null;

      if (this.Items && this.Items.length > 0) {
        this.Items.forEach(e => {
          fnbamount += e.fp_amount;
        });
        return fnbamount;
      } else {
        return (fnbamount = 0.0);
      }
    },
    TaxesTotal() {
      return this.taxesTotal ? this.taxesTotal : null;
    },
    totalAmount() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    ...mapGetters([
      "TOTAL_AMOUNT",
      "isBoxofficeflag",
      "IDforBoxOfficeEjs",
      "IDforFnBEjs"
    ]),
    ...mapState({
      FnBItemsTotalPrice: state =>
        state.FnBStore.selectedFnBItemsTotalPrice +
        state.FnBStore.totalAdditionalTaxes
    })
  },
  mounted() {
    this.currentDate = moment().format("DD/MM/YY HH:mm");
    this.name = this.secureStore.get("USINFO").first_name;

    EventBus.$on("printBO&FnbReceipt", () => {
      // this.print();
      this.GetEjsTicket();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printBO&FnbReceipt");
  },
  methods: {
    GetEjsTicket: function() {
      let loader = this.$loading.show();
      if (!("ft_id" in this.IDforFnBEjs)) {
        this.IDforFnBEjs.ft_id = 0;
      }

      PosService.GetReceiptEjs(
        this.IDforBoxOfficeEjs.sb_id,
        this.IDforFnBEjs.ft_id,
        this.IDforBoxOfficeEjs.cinema_id,
        "BoxOfficeFnBReceipt"
      )
        .then(response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.boxofficefnb_SalesReceipt) {
        p.print(this.$refs.boxofficefnb_SalesReceipt, []);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/ReceiptTemplates/bo&fnb_sales_receipt.vue